export default __webpack_public_path__ + "static/media/photoCard.3c4e8771.webp";